import React, { memo } from 'react';

const ImageComponent = memo(({ src, alt }) => <img 
    src={src} 
    loading="lazy" 
    alt={alt}/>
);

export {
    ImageComponent
}